import React from 'react';
import { Redirect } from 'react-router-dom';
import { AuthenticationService } from '@knockrentals/knock-react';
import { ACCESS_TOKEN_LOGIN_TYPE } from '../../constants';

const LogoutPage = () => {
  localStorage.removeItem(ACCESS_TOKEN_LOGIN_TYPE);
  AuthenticationService.clearToken();

  return <Redirect to={{ pathname: '/login' }} />;
};

export default LogoutPage;
